<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE USUARIOS</h3>
          </div>
          <div class="box-body">
            <!---- Tabla Usuarios Cas --->
            <form role="form">
              <div class="box-footer" style="padding-left:15px;">
                <button type="button" class="fuente btn btn-primary fs-13" @click="limpiar()" data-toggle="modal"
                  data-target="#modalNuevo">Nuevo Registro</button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <h3 class="fuente box-title p-t-15 fuente-subtitulo">USUARIOS CAS</h3>
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="NOMBRE" aria-controls="tablaDetalle" tabindex="0" class="sorting_asc">NOMBRE
                          </th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">MODIFICAR PASSWORD
                          </th>
                          <!--<th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">ANULAR</th>-->
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">APLICACIÓN
                          </th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">ÁREA</th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">ROL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in users" v-if="users.length > 0">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.nomUsuario }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue" data-toggle="modal" @click="ver(item)"
                              data-target="#modalNuevo">O</span></td>
                          <!--- <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                              @click="verAnular(item)" data-target="#modalAnular">X</span></td> -->

                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-yellow" data-toggle="modal"
                              @click="verApps(item)" data-target="#modalApp">P</span></td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-brown" data-toggle="modal"
                              @click="verArea(item)" data-target="#modalArea">A</span></td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-yellow" data-toggle="modal"
                              @click="verRols(item)" data-target="#modalRol">R</span></td>
                        </tr>
                        <tr v-if="users.length == 0">
                          <td colspan="6" class="text-center">No hay usuario registrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        <div class="row">
                          <div class="col-md-6">
                            Usuario
                            <input type="text" class="form-control m-t-10 m-b-10" required="true"
                              v-model="user.nomUsuario" placeholder="Ingrese Usuario" :disabled="user.idUsuario !== '0'" />
                          </div>
                          <div class="col-md-6">
                            Password
                            <input type="password" class="form-control m-t-10" required="true" v-model="user.clave"
                              placeholder="Ingrese Clave" />
                          </div>
                        </div>
                      </div>
                      <div class="fuente col-md-12"
                        style="color: red; font-size: 12px; padding-top: 10px; padding-bottom: 15px">
                        El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido
                        el guión abajo y por último su número de DNI.
                      </div>
                      <div class="modal-footer">
                        <button v-if="nuevo" type="button" class="fuente btn btn-primary fs-13" @click="mergeAuth()"
                          data-dismiss="modal" :disabled="user.nomUsuario == ''">Guardar Cambios</button>
                        <button v-if="editar" type="button" class="fuente btn btn-primary fs-13" @click="merge()"
                          data-dismiss="modal">Actualizar Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!----
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEA ANULAR EL USUARIO?</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará el usuario {{ user.nomUsuario }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Usuario</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              ---->
              <div class="modal fade" id="modalApp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">APLICACIONES DE: {{ user.nomUsuario }}
                        </h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        <div class="row">
                          <div class="col-md-9">
                            Aplicación:
                            <!----
                            <select class="form-control m-t-10" v-model="appByUsu.idApp">
                              <option v-for="app in apps" v-bind:value="app.idApp">
                                {{ app.descripcion }}
                              </option>
                            </select>
                            ---->
                            <v-select v-model="selectedIdAplicacion" :options="filteredAplicaciones" :filterable="true"
                              label="nombreAplicacion" @input="selectAplicacion" class="fuente m-t-10 m-b-10"
                              placeholder="Seleccionar"
                              style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                              <template v-slot:no-options="{ search }">
                                Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-3">
                            <button type="button" class="fuente btn btn-primary fs-13 m-t-27"
                              @click="mergeAppByUsu(user.idUsuario)" :disabled="appByUsu.idApp == '0'"
                              :title="(appByUsu.idApp == '0') ? 'Para agregar, seleccione una aplicación' : ''">Agregar
                              +</button>
                          </div>
                          <div class="fuente col-md-12" style="color: red;">
                            <br><br>
                            {{ errorApp.desError }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <br />
                            <table aria-describedby="tablaDetalle_info" role="grid" id="tbApps"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tbApps" tabindex="0">ITEM
                                  </th>
                                  <th aria-label="APP" aria-controls="tbApps" tabindex="0">APLICACION</th>
                                  <th aria-label="ANULAR" aria-controls="tbApps" tabindex="0">ANULAR</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="even" role="row" v-for="item in appById">
                                  <td class="sorting_1">{{ item.cont }}</td>
                                  <td>{{ item.descripcion }}</td>
                                  <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="anulaAppByUsu(item)">X</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" data-dismiss="modal">Cancelar</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalRol" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">ROLES ASIGNADOS A {{ user.nomUsuario }}
                        </h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        <div class="row">
                          <div class="col-md-9">
                            Aplicación:
                            <!----
                            <select class="form-control m-t-10 m-b-10" v-on:change="cargaRols(rolByUsu.idApp)"
                              v-model="rolByUsu.idApp">
                              <option v-for="app in appById" v-bind:value="app.idApp">
                                {{ app.descripcion }}
                              </option>
                            </select>
                            ---->
                            <v-select v-model="selectedAppById" :options="filteredAppsById" :filterable="true"
                              label="nombreAppById" @input="selectAppById" class="fuente form-control m-t-10 m-b-10"
                              placeholder="Seleccionar"
                              style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                              <template v-slot:no-options="{ search }">
                                <span v-if="appById.length === 0">
                                  Lo siento, este usuario no tiene aplicaciones registradas.
                                </span>
                                <span v-else>
                                  Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                                </span>
                              </template>
                            </v-select>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-9">
                            Rol:
                            <!----
                            <select class="form-control m-t-10" v-model="rolByUsu.idRol" :disabled ="!selectedAppById">
                              <option v-for="app in rolByApp" v-bind:value="app.idRol">
                                {{ app.descripcion }}
                              </option>
                            </select>
                            ---->
                            <v-select v-model="selectedIdRol" :options="filteredRoles" :filterable="true"
                              label="nombreRol" @input="selectRol" class="fuente form-control m-t-10 m-b-10"
                              placeholder="Seleccionar"
                              style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                              <template v-slot:no-options="{ search }">
                                <span v-if="!selectedAppById">
                                  Primero, debe seleccionar una aplicación.
                                </span>
                                <span v-else-if="rolByApp.length === 0">
                                  Lo siento, esta aplicación no tiene roles registrados.
                                </span>
                                <span v-else>
                                  Lo siento, no hay roles que coincidan con "{{ search }}".
                                </span>
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-3">
                            <button type="button" @click="mergeRolByUsu(user.idUsuario)"
                              class="fuente btn btn-primary fs-13 m-t-27" :disabled="!selectedIdRol"
                              :title="(!selectedIdRol) ? 'Para agregar, primero seleccione de las listas desplegables una Aplicación y luego un Rol' : ''">Agregar
                              +</button>
                          </div>
                          <div class="fuente col-md-12" style="color: red;">
                            {{ errorRol.desError }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <br />
                            <table aria-describedby="tablaDetalle_info" role="grid" id="tbRols"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tbRols" tabindex="0">ITEM
                                  </th>
                                  <th aria-label="APP" aria-controls="tbRols" tabindex="0">ROL</th>
                                  <th aria-label="ANULAR" aria-controls="tbRols" tabindex="0">ANULAR</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="even" role="row" v-for="item in rolById">
                                  <td class="sorting_1">{{ item.cont }}</td>
                                  <td>{{ item.descripcion }}</td>
                                  <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="anularRolByUsu(item)">X</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" data-dismiss="modal">Cancelar</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalArea" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">AGREGAR ÁREA PARA {{ user.nomUsuario }}
                        </h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        <div class="row">
                          <div class="col-md-4 m-b-10">
                            Flag Seteo:
                            <input type="checkbox" v-model="areaByUsu.flagSeteo" true-value="1" false-value="0">
                          </div>
                          <div class="col-md-4">
                            Flag Defecto:
                            <input type="checkbox" v-model="areaByUsu.flagDefecto" true-value="1"
                              false-value="0"><br /><br />
                          </div>
                          <div class="col-md-9 m-b-20">
                            <!----
                            <select class="form-control" v-model="areaByUsu.idArea">
                              <option v-for="app in areas" v-bind:value="app.idArea">
                                {{ app.descripcion }}
                              </option>
                            </select>
                            ---->
                            <v-select v-model="selectedIdArea" :options="filteredAreas" :filterable="true"
                              label="nombreArea" @input="selectArea" class="fuente m-t-10 m-b-10"
                              placeholder="Seleccionar"
                              style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                              <template v-slot:no-options="{ search }">
                                Lo siento, no hay áreas que coincidan con "{{ search }}".
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-3">
                            <button type="button" @click="mergeAreaByUsu(user.idUsuario)"
                              class="fuente btn btn-primary fs-13" :disabled="areaByUsu.idArea == '0'"
                              :title="(areaByUsu.idArea == '0') ? 'Para agregar, seleccione un Área' : ''">Agregar
                              +</button>
                          </div>
                          <div class="fuente col-md-12" style="color: red;">
                            {{ errorArea.desError }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <br />
                            <table aria-describedby="tablaDetalle_info" role="grid" id="tbRols"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tbRols" tabindex="0">ITEM
                                  </th>
                                  <th aria-label="APP" aria-controls="tbRols" tabindex="0">ÁREA</th>
                                  <th aria-label="APP" aria-controls="tbRols" tabindex="0">SETEO</th>
                                  <th aria-label="APP" aria-controls="tbRols" tabindex="0">DEFECTO</th>
                                  <th aria-label="ANULAR" aria-controls="tbRols" tabindex="0">ANULAR</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="even" role="row" v-for="item in areaById">
                                  <td class="sorting_1">{{ item.cont }}</td>
                                  <td>{{ item.descripcion }}</td>
                                  <td>{{ item.seteo }}</td>
                                  <td>{{ item.defecto }}</td>
                                  <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="anularAreaByUsu(item)">X</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" data-dismiss="modal">Cancelar</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form><br>

            <!---------- Tabla Usuarios Auth ------->
            <form role="form">
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <h3 class="fuente box-title p-t-15 fuente-subtitulo">USUARIOS AUTH</h3>
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="NOMBRE" aria-controls="tablaDetalle" tabindex="0" class="sorting_asc">NOMBRE
                          </th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">MODIFICAR PASSWORD
                          </th>
                          <!--- 
                            <th aria-label="ANULAR" aria-controls="tablaDetalle2" tabindex="0"
                            class="sorting table-center-header">ANULAR</th>
                            --->
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-if="users.length > 0">
                          <td class="sorting_1">{{ usersAuth.cont }}</td>
                          <td>{{ usersAuth.nomUsuario }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                              data-toggle="modal" @click="verDataAuth(usersAuth)" data-target="#modalEditAuth">O</span>
                          </td>
                          <!--- 
                            <td class="table-center-header"><span style="cursor:pointer" class="badge bg-red"
                              data-toggle="modal" @click="verDataAuth(usersAuth)" data-target="#modalAnularAuth">X</span>
                          </td>
                          --->
                        </tr>
                        <tr v-else>
                          <td colspan="3" class="text-center">No hay usuario registrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error2.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalEditAuth" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        <div class="row">
                          <div class="col-md-6">
                            Usuario
                            <input type="text" class="form-control m-t-10 m-b-10" required="true" v-model="userAuth"
                              placeholder="Ingrese Usuario" disabled />
                          </div>
                          <div class="col-md-6">
                            Password
                            <input type="password" class="form-control m-t-10" required="true" v-model="claveAuth"
                              placeholder="Ingrese Clave" :disabled="!userAuth"/>
                          </div>
                        </div>
                      </div>
                      <div class="fuente col-md-12"
                        style="color: red; font-size: 12px; padding-top: 10px; padding-bottom: 15px">
                        El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido
                        el guión abajo y por último su número de DNI.
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-primary fs-13" @click="editarAuth()"
                          data-dismiss="modal" :disabled="userAuth == ''">Actualizar Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnularAuth" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEA ANULAR LOS USUARIOS?</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anularán los usuarios CAS y AUTH {{ usersAuth.nomUsuario }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="anularAuth()"
                          data-dismiss="modal">Anular Usuarios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
            <form role="form">
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="col-md-10">
                  </div>
                  <div class="col-md-2">
                    <div class="box-footer" style="padding-left:15px;">
                      <button type="button" class="fuente btn btn-danger fs-13" @click="verAnular(usersAuth)"
                        data-toggle="modal" data-target="#modalAnularAuth" :disabled="this.users.length == 0">Anular Usuarios</button>
                    </div>                    
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

require('moment')
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiAUTH } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      authorization: 'Bearer ' + localStorage.getItem('AccessToken'),
      nuevo: false,
      editar: false,
      vidApp: '0',
      vidUsu: '0',
      texto: '',
      users: [], ///UsuariosCas
      usersAuth: [], ///UsuariosAuth
      error: {
        desError: ''
      },
      error2: {
        desError: ''
      },
      errorApp: {
        desError: ''
      },
      errorArea: {
        desError: ''
      },
      errorRol: {
        desError: ''
      },
      appById: [],
      rolById: [],
      rolByApp: [],
      apps: [],
      areas: [],
      areaById: [],
      areaByUsu: {
        idArea: '0',
        idAreaXUsu: '0',
        idUsuario: '0',
        flagSeteo: '0',
        flagDefecto: '0',
        descripcion: '',
        tipo: 'C',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      rolByUsu: {
        idRol: '0',
        idUsuario: '0',
        idApp: '1',
        flagActivo: '1',
        idRolXUsu: '0',
        usuario: this.$session.get('user')
      },
      appByUsu: {
        idUsuario: '0',
        idAppXUsu: '0',
        idApp: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      user: {
        idUsuario: '0',
        nomUsuario: '',
        clave: '',
        idTrabajador: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      trabs: [],
      trabs1: [],
      trabs2: [],
      allTrabs: [], /// Array que concatena trabs, trabs1 y trabs2
      AuthFilter: [], ///Devuelve del apiAUTH los datos de un usuarioAuth filtrado
      idPersona: '', /// del modalEditAuth y modalAnularAuth
      userAuth: '', /// del modalEditAuth 
      claveAuth: '', /// del modalEditAuth
      emailAuth: '', /// del modalEditAuth
      tiempoActual: null,
      tiempoTokenExp: null,
      //// del v-select del modalApp
      searchTextApp: '',
      selectedIdAplicacion: null,
      appSeleccionada: {},
      //// del v-select del modalArea
      searchTextArea: '',
      selectedIdArea: null,
      areaSeleccionada: {},
      //// del v-select 1 del modalRol      
      searchTextAppById: '',
      selectedAppById: null,
      appByIdSeleccionada: {},
      /// del v-select 2 del modalRol
      searchTextRol: '',
      selectedIdRol: null,
      rolSeleccionado: {},
      storedIdTrab: localStorage.getItem('userIdTrab'),
      storedUserMail: localStorage.getItem('userMail')
    }
  },
  components: {
    vSelect
  },
  mounted() {    
    //console.log('ruta /:idTrab', this.$route.params.idTrab)

    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");

    if (this.tiempoActual < this.tiempoTokenExp) {      
      if (this.storedUserMail && this.storedUserMail !== '' && this.storedIdTrab && this.storedIdTrab !== '') {        
        this.carga()
      } else {
        //this.$router.push('/trabajadores')
        //this.$router.push('/personal')
        this.$router.go(-1)
        //console.error('No hay userMail.');
      }
    } else {
      this.alertaError401();
    }
  },
  methods: {
    carga() {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/usuarios/trabajador/` + this.storedIdTrab
      ).then(response => {
        this.users = response.data
        ///Obtener el primer array de users para la tabla usuariosAuth
        if (this.users.length > 0) {
          this.usersAuth = response.data[0]
        } else {
          this.usersAuth = []
        }

        /*
        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': ' ',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
        */
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    merge: function () {
      axios.post(
        `${apiURL}/operaciones/usuario/add`,
        {
          'idUsuario': this.user.idUsuario,
          'nomUsuario': this.user.nomUsuario,
          'clave': this.user.clave,
          'idTrabajador': this.storedIdTrab,
          'flagActivo': this.user.flagActivo,
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error = response.data
        axios.get(
          `${apiURL}/usuarios/trabajador/` + this.storedIdTrab
        ).then(response => {
          this.users = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    mergeAuth: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        let data =
        {
          'connection': 'TC-BD',
          //'email': this.$store.state.userMail,
          'email': this.storedUserMail,
          'username': this.user.nomUsuario,
          'password': this.user.clave,
          'user_metadata': {},
          'email_verified': true,
          'app_metadata': {},
          'given_name': this.user.nomUsuario,
          'family_name': 'TC',
          //'name': this.$store.state.userMail,
          'name': this.storedUserMail,
          'nickname': this.user.nomUsuario
        }
        //axios.post('https://tcperu.auth0.com/api/v2/users', data, {crossdomain: true,
        axios.post(`${apiAUTH}/users`, data, {
          crossdomain: true,
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.merge();
        })
          .catch(error => {
          })
      } else {
        this.alertaError401();
      }
    },
    ver: function (user) {
      this.nuevo = false
      this.editar = true
      this.texto = 'ACTUALIZAR DATOS DE USUARIO CAS'
      this.user = user
    },
    verAnular: function (user) {
      //this.limpiarAuth();
      this.user = user
      this.user.flagActivo = '0'
      this.user.nomUsuario = user.nomUsuario
      //Filtrar de apiAUTH  para obtener los datos del usuario que su username sea igual al usersAuth.nomUsuario
      this.getDatosAuth(this.user.nomUsuario);
    },
    verArea: function (user) {
      this.user = user
      this.areaByUsu.idArea = '0'
      this.areaByUsu.idUsuario = this.user.idUsuario
      this.areaByUsu.idAreaXUsu = '0'
      this.areaByUsu.flagSeteo = '0'
      this.areaByUsu.flagDefecto = '0'
      this.vidUsu = '0'
      this.error.desError = ''
      this.errorArea.desError = ''
      this.selectedIdArea = null
      this.areaSeleccionada = {}
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/area/*`
      ).then(response => {
        this.areas = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/areaByUsu/` + this.user.idUsuario
      ).then(response => {
        this.areaById = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    verApps: function (user) {
      this.user = user
      this.appByUsu.idUsuario = this.user.idUsuario
      this.appByUsu.idAppXUsu = '0'
      this.appByUsu.idApp = '0'
      this.vidUsu = '0'
      this.error.desError = ''
      this.errorApp.desError = ''
      this.selectedIdAplicacion = null
      this.appSeleccionada = {}

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/aplicaciones/*`
      ).then(response => {
        this.apps = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/aplicaciones/appById/` + this.user.idUsuario
      ).then(response => {
        this.appById = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    mergeAreaByUsu: function (vidUsu) {
      this.areaByUsu.idUsuario = vidUsu
      axios.post(
        `${apiURL}/operaciones/areaByUsu/add`,
        {
          'idAreaXUsu': '0',
          'idUsuario': this.areaByUsu.idUsuario,
          'idArea': this.areaByUsu.idArea,
          'flagActivo': this.areaByUsu.flagActivo,
          'flagSeteo': this.areaByUsu.flagSeteo,
          'flagDefecto': this.areaByUsu.flagDefecto,
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorArea = response.data
        this.selectedIdArea = null ///limpia la selección en el v-select del modalArea
        this.areaByUsu.idArea = '0' /// limpia el id del área seleccionado en el modalArea
        this.areaByUsu.flagSeteo = '0'
        this.areaByUsu.flagDefecto = '0'
        axios.get(
          `${apiURL}/operaciones/areaByUsu/` + this.user.idUsuario
        ).then(response => {
          this.areaById = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    anularAreaByUsu: function (areaByUsu) {
      this.areaByUsu.idUsuario = areaByUsu.idUsuario
      this.areaByUsu.idAreaXUsu = areaByUsu.idAreaXUsu
      axios.post(
        `${apiURL}/operaciones/areaByUsu/add`,
        {
          'idAreaXUsu': this.areaByUsu.idAreaXUsu,
          'idUsuario': this.areaByUsu.idUsuario,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorArea = response.data
        axios.get(
          `${apiURL}/operaciones/areaByUsu/` + this.user.idUsuario
        ).then(response => {
          this.areaById = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    mergeAppByUsu: function (vidUsu) {
      this.appByUsu.idUsuario = vidUsu
      axios.post(
        `${apiURL}/operaciones/appByUsu/add`,
        {
          'idAppXUsu': '0',
          'idUsuario': this.appByUsu.idUsuario,
          'idApp': this.appByUsu.idApp,
          'flagActivo': this.appByUsu.flagActivo,
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorApp = response.data
        this.selectedIdAplicacion = null ///limpia la selección en el v-select del modalApp
        this.appByUsu.idApp = '0' /// limpia el id de la aplicación seleccionada en el modalApp
        axios.get(
          `${apiURL}/aplicaciones/appById/` + this.user.idUsuario
        ).then(response => {
          this.appById = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    anulaAppByUsu: function (appByUsu) {
      this.appByUsu.idUsuario = appByUsu.idUsuario
      this.appByUsu.idAppXUsu = appByUsu.idAppXUsu
      axios.post(
        `${apiURL}/operaciones/appByUsu/add`,
        {
          'idUsuario': this.appByUsu.idUsuario,
          'idAppXUsu': this.appByUsu.idAppXUsu,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorApp = response.data
        axios.get(
          `${apiURL}/aplicaciones/appById/` + this.user.idUsuario
        ).then(response => {
          this.appById = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    mergeRolByUsu: function (vidUsu) {
      this.rolByUsu.idUsuario = vidUsu
      axios.post(
        `${apiURL}/operaciones/rolByUsu/add`,
        {
          'idRolXUsu': '0',
          'idUsuario': this.rolByUsu.idUsuario,
          'idRol': this.rolByUsu.idRol,
          'flagActivo': this.rolByUsu.flagActivo,
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorRol = response.data
        axios.get(
          `${apiURL}/operaciones/rolByUsu/` + this.user.idUsuario + '/' + this.rolByUsu.idApp
        ).then(response => {
          this.rolById = response.data
          this.selectedIdRol = null
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    anularRolByUsu: function (rolByUsu) {
      this.rolByUsu.idUsuario = rolByUsu.idUsuario
      this.rolByUsu.idRolXUsu = rolByUsu.idRolXUsu
      axios.post(
        `${apiURL}/operaciones/rolByUsu/add`,
        {
          'idUsuario': this.rolByUsu.idUsuario,
          'idRol': this.rolByUsu.idRol,
          'idRolXUsu': this.rolByUsu.idRolXUsu,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.errorRol = response.data
        axios.get(
          `${apiURL}/operaciones/rolByUsu/` + this.user.idUsuario + '/' + this.rolByUsu.idApp
        ).then(response => {
          this.rolById = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    verRols: function (user) {
      this.user = user
      this.rolByUsu.idApp = '1'
      this.rolByUsu.idUsuario = this.user.idUsuario
      this.rolByUsu.idRol = '0'
      this.vidUsu = '0'
      this.error.desError = ''
      this.errorRol.desError = ''
      this.selectedAppById = null
      this.selectedIdRol = null

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/aplicaciones/appById/` + this.user.idUsuario
      ).then(response => {
        this.appById = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/rolByUsu/` + this.user.idUsuario + '/1'
      ).then(response => {
        this.rolById = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/rolByApp/1`
      ).then(response => {
        this.rolByApp = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    cargaRols: function (vidApp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/rolByApp/` + vidApp
      ).then(response => {
        this.rolByApp = response.data
        //console.log(this.rolByApp)
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/operaciones/rolByUsu/` + this.user.idUsuario + '/' + vidApp
      ).then(response => {
        this.rolById = response.data
        //console.log(this.rolById)
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    limpiar: function () {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        `${apiURL}/usuarios/trabajador/` + this.storedIdTrab
      ).then(response => {
        this.editar = false;
        this.nuevo = true;
        this.users = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'AGREGAR NUEVO USUARIO'
      this.error.desError = ''
      this.user.idUsuario = '0'
      this.user.nomUsuario = ''
      this.user.clave = ''
      this.user.idTrabajador = this.storedIdTrab
      this.user.flagActivo = '1'
    },

    ///// De la tabla UsuariosAuth ///
    verDataAuth: function (item) {
      this.limpiarAuth();
      this.user.nomUsuario = item.nomUsuario
      //Filtrar de apiAUTH  para obtener los datos del usuario que su username sea igual al usersAuth.nomUsuario
      this.getDatosAuth(this.user.nomUsuario);
      this.texto = 'ACTUALIZAR DATOS DE USUARIO AUTH'
    },
    limpiarAuth() {
      this.userAuth = ''
      this.claveAuth = ''
      this.error2.desError = ''
    },
    getDatosAuth(nomUsuario) {
      axios.defaults.headers.common['Authorization'] = this.authorization
      //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=0&search_engine=v3'
      axios.get(`${apiAUTH}/users?per_page=100&page=0&search_engine=v3`
      ).then(response => {
        this.trabs = response.data
        axios.defaults.headers.common['Authorization'] = this.authorization
        //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=1&search_engine=v3'
        axios.get(`${apiAUTH}/users?per_page=100&page=1&search_engine=v3`
        ).then(response => {
          this.trabs1 = response.data
          axios.defaults.headers.common['Authorization'] = this.authorization
          //axios.get('https://tcperu.auth0.com/api/v2/users?per_page=100&page=2&search_engine=v3'
          axios.get(`${apiAUTH}/users?per_page=100&page=2&search_engine=v3`
          ).then(response => {
            this.trabs2 = response.data
            this.allTrabs = this.trabs.concat(this.trabs1, this.trabs2)
            //console.log('this.allTrabs', this.allTrabs)

            // Filtrar allTrabs para obtener el array que su username sea igual al nomUsuario de this.usersAuth 
            this.AuthFilter = this.allTrabs.flat().find(usu => usu.username.toLowerCase() === nomUsuario.toLowerCase());
            //console.log('Resultado filtrado de allTrabs:', this.AuthFilter);

            if (this.AuthFilter && this.AuthFilter.user_id) {
              this.idPersona = this.AuthFilter.user_id
              this.userAuth = this.AuthFilter.username
              this.emailAuth = this.AuthFilter.email
              //console.log('', this.idPersona, this.userAuth, this.emailAuth)
            }

          })
            .catch(error => {
              if (error.response && error.response.status === 401) {
                App.methods.logout.call(this);
              }
            })
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    editarAuth() {
      //console.log('---', this.idPersona, this.userAuth, this.claveAuth)      
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        if (this.claveAuth != '' && this.userAuth != '') {
          this.isLoading = true;
          axios.patch(
            //'https://tcperu.auth0.com/api/v2/users/' + this.idPersona,
            `${apiAUTH}/users/` + this.idPersona,
            {
              "blocked": false,
              "password": this.claveAuth,
              "user_metadata": {},
              "app_metadata": {},
              "connection": "TC-BD",
              "client_id": "MxzsgeU7uo8lTkIaKYgpwyKrbELw7I5n"
            }
          ).then(response => {
            axios.patch(
              //'https://tcperu.auth0.com/api/v2/users/' + this.idPersona, 
              `${apiAUTH}/users/` + this.idPersona,
              {
                "blocked": false,
                "username": this.userAuth,
                "user_metadata": {},
                "app_metadata": {},
                "connection": "TC-BD",
                "client_id": "MxzsgeU7uo8lTkIaKYgpwyKrbELw7I5n"
              }
            ).then(response => {
              this.isLoading = false;
              this.carga();
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  this.isLoading = false;
                  App.methods.logout.call(this);
                }
              })
          })
            .catch(error => {
              if (error.response && error.response.status === 401) {
                this.isLoading = false;
                App.methods.logout.call(this);
              }
            })
        } else if (this.claveAuth == '' && this.userAuth != '') {
          this.isLoading = true;
          axios.patch(
            //'https://tcperu.auth0.com/api/v2/users/' + this.idPersona, 
            `${apiAUTH}/users/` + this.idPersona,
            {
              "blocked": false,
              "username": this.userAuth,
              "user_metadata": {},
              "app_metadata": {},
              "connection": "TC-BD",
              "client_id": "MxzsgeU7uo8lTkIaKYgpwyKrbELw7I5n"
            }
          ).then(response => {
            this.isLoading = false;
            this.carga();
          })
            .catch(error => {
              if (error.response && error.response.status === 401) {
                this.isLoading = false;
                App.methods.logout.call(this);
              }
            })
        } else { }
      } else {
        this.alertaError401();
      }
    },
    ///// Anular tanto a los usuariosCas y al usuarioAuth
    anularAuth() {
      //console.log('this.users', this.users)
      //console.log('this.user', this.user)
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        this.isLoading = true;
        //// Para anular:
        if (this.user.flagActivo == '0') {
          //// 1) Si users (todos los usuarios Cas) no esta vacío, forEach a cada idUsuario obtenido 
          if (this.users.length > 0) {
            this.users.forEach(array1 => {
              ///// 2) Para anular las relaciones aplicacionxusuario y rolxusuario, buscar cada idAppXUsu e idRolxUsu
              axios.defaults.headers.common['Authorization'] = this.$session.get('token')
              axios.get(
                `${apiURL}/aplicaciones/appById/` + array1.idUsuario
              ).then(response => {
                this.appById = response.data
                //console.log('appById', this.appById)
                ////// 3) Si appById no esta vacío, realizar un forEach
                if (this.appById.length > 0) {
                  this.appById.forEach(array2 => {
                    ////// 4) Primero anular cada rolxusuario, para ello buscar cada idRolXUsu
                    axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                    axios.get(
                      `${apiURL}/operaciones/rolByUsu/` + array1.idUsuario + '/' + array2.idApp
                    ).then(response => {
                      this.rolById = response.data
                      //console.log('rolById', this.rolById)
                      ////// 5) Si rolById no esta vacío, realizar un forEach y anular cada rolxusuario                        
                      if (this.rolById.length > 0) {
                        this.rolById.forEach(array3 => {
                          axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                          axios.post(
                            `${apiURL}/operaciones/rolByUsu/add`,
                            {
                              'idUsuario': array1.idUsuario,
                              'idRol': array3.idRol,
                              'idRolXUsu': array3.idRolXUsu,
                              'flagActivo': '0',
                              'usuario': this.$session.get('user')
                            }
                          ).then(response => {
                            this.error = response.data
                            ///// Se anula cada rolxusuario de este usuario                       
                          })
                            .catch(error => {
                              if (error.response && error.response.status === 401) {
                                App.methods.logout.call(this);
                              }
                            })
                        })
                      }
                    })
                      .catch(error => {
                        if (error.response && error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                    /// 6) Y anular cada aplicacionxusuario
                    axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                    axios.post(
                      `${apiURL}/operaciones/appByUsu/add`,
                      {
                        'idUsuario': array1.idUsuario,
                        'idAppXUsu': array2.idAppXUsu,
                        'flagActivo': '0',
                        'usuario': this.$session.get('user')
                      }
                    ).then(response => {
                      this.error = response.data
                      //// Se anula cada relación aplicacionxusuario de este usuario
                    })
                      .catch(error => {
                        if (error.response && error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  })
                }
              })
                .catch(error => {
                  if (error.response && error.response.status === 401) {
                    App.methods.logout.call(this);
                  }
                })

              ///// 7) Para anular cada relación areaxusuario, buscar cada idAreaXUsu
              axios.defaults.headers.common['Authorization'] = this.$session.get('token')
              axios.get(
                `${apiURL}/operaciones/areaByUsu/` + array1.idUsuario
              ).then(response => {
                this.areaById = response.data
                //console.log('areaById', this.areaById)
                ////// 8) Si areaById no esta vacío, realizar forEach para anular a cada areaxusuario
                if (this.areaById.length > 0) {
                  this.areaById.forEach(array4 => {
                    axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                    axios.post(
                      `${apiURL}/operaciones/areaByUsu/add`,
                      {
                        'idAreaXUsu': array4.idAreaXUsu,
                        'idUsuario': array1.idUsuario,
                        'flagActivo': '0',
                        'usuario': this.$session.get('user')
                      }
                    ).then(response => {
                      this.error = response.data
                      ///// Se anula cada relación areaxusuario de este usuario              
                    })
                      .catch(error => {
                        if (error.response && error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  })
                }
              })
                .catch(error => {
                  if (error.response && error.response.status === 401) {
                    App.methods.logout.call(this);
                  }
                })
              ///// 9) Anular cada Usuario Cas
              axios.defaults.headers.common['Authorization'] = this.$session.get('token')
              axios.post(
                `${apiURL}/operaciones/usuario/add`,
                {
                  'idUsuario': array1.idUsuario,
                  'nomUsuario': array1.nomUsuario,
                  'clave': array1.clave,
                  'idTrabajador': array1.idTrabajador,
                  'flagActivo': '0',
                  'usuario': this.$session.get('user')
                }
              ).then(response => {
                this.error = response.data
                this.error2 = response.data
                this.carga()
              })
                .catch(error => {
                  if (error.response && error.response.status === 401) {
                    App.methods.logout.call(this);
                  }
                })
            });
          } else { }

          //// 10) Anular el usuarioAuth con this.idPersona que tiene el user_id del apiAUTH 
          if (this.AuthFilter.length > 0 && this.idPersona !== '') {
            axios.defaults.headers.common['Authorization'] = this.authorization
            //axios.delete('https://tcperu.auth0.com/api/v2/users/' + this.idPersona
            axios.delete(`${apiAUTH}/users/` + this.idPersona
            ).then(response => {
              //// usuarioAUTH eliminado del apiAUTH  
              this.isLoading = false;
              this.carga();
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  this.isLoading = false;
                  App.methods.logout.call(this);
                }
              })
          }
        }
      } else {
        this.alertaError401();
      }
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$router.go(-1);
        this.$router.push('/login')
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión 
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$router.go(-1);
        this.$router.push('/login')
      });
    },
    /// del v-select del modalApp
    selectAplicacion() {
      if (this.selectedIdAplicacion && this.selectedIdAplicacion.idApp) {
        //console.log('Ejecutando selectAplicacion', this.selectedIdAplicacion);        
        const newIdApp = this.selectedIdAplicacion.idApp;
        const selectedApp = this.apps.find(a => a.idApp === newIdApp) || {};
        this.appByUsu.idApp = selectedApp.idApp || '0';
        //console.log('appByUsu', this.appByUsu)                       
        this.appSeleccionada = selectedApp;
        this.error.desError = ''
        this.errorApp.desError = ''
        //console.log('Aplicacion seleccionada:', this.appSeleccionada);        
      } else {
        //console.warn('selectedIdAplicacion es null o no tiene id');        
        this.appSeleccionada = {};
        ///Actualizar con datos vacios cuando no hay selección en el v-select
        this.appByUsu.idApp = this.appSeleccionada.idApp || '0';
        this.error.desError = ''
        this.errorApp.desError = ''
        //console.log('appByUsu', this.appByUsu)        
      }
    },
    /// del v-select del modalArea
    selectArea() {
      if (this.selectedIdArea && this.selectedIdArea.idArea) {
        //console.log('Ejecutando selectArea', this.selectedIdArea);

        const newIdArea = this.selectedIdArea.idArea;
        const selectedArea = this.areas.find(a => a.idArea === newIdArea) || {};
        this.areaByUsu.idArea = selectedArea.idArea || '0';
        //this.areaByUsu.flagSeteo = '1';
        this.areaByUsu.flagSeteo = selectedArea.flagSeteo || '1';
        //this.areaByUsu.flagDefecto = selectedArea.flagDefecto || '0';        

        //console.log('areaByUsu', this.areaByUsu)
        this.areaSeleccionada = selectedArea;
        //console.log('Area seleccionada:', this.areaSeleccionada);
        this.error.desError = ''
        this.errorArea.desError = ''
      } else {
        //console.warn('selectedIdArea es null o no tiene id');        
        this.areaSeleccionada = {};
        ///Actualizar con datos vacios cuando no hay selección en el v-select
        this.areaByUsu.idArea = this.areaSeleccionada.idArea || '0';
        this.areaByUsu.flagSeteo = this.areaSeleccionada.flagSeteo || '0'
        this.areaByUsu.flagDefecto = this.areaSeleccionada.flagDefecto || '0'
        this.error.desError = ''
        this.errorArea.desError = ''
        //console.log('areaByUsu', this.areaByUsu)
      }
    },

    selectAppById() {
      if (this.selectedAppById && this.selectedAppById.idApp) {
        //console.log('Ejecutando selectAppById', this.selectedAppById);
        this.cargaRols(this.selectedAppById.idApp)

        this.rolByUsu.idApp = this.selectedAppById.idApp || '0';
        this.error.desError = ''
        this.errorRol.desError = ''
        //console.log('rolByUsu', this.rolByUsu)           
      } else {
        //console.warn('selectedAppById es null o no tiene id');         
        this.rolByApp = []
        this.rolById = []
        this.selectedIdRol = null
        this.rolByUsu.idRol = '0';
        this.error.desError = ''
        this.errorRol.desError = '' 
      }
    },
    /// del v-select del modalArea
    selectRol() {
      if (this.selectedIdRol && this.selectedIdRol.idRol) {
        //console.log('Ejecutando selectRol', this.selectedIdRol);
        this.rolByUsu.idRol = this.selectedIdRol.idRol || '0';
        this.error.desError = ''
        this.errorRol.desError = ''
        //console.log('rolByUsu', this.rolByUsu)        
      } else {
        //console.warn('selectedIdArea es null o no tiene id');                
        ///Actualizar con datos vacios cuando no hay selección en el v-select             
        this.rolByUsu.idRol = '0';
        this.error.desError = ''
        this.errorRol.desError = ''
        //console.log('rolByUsu', this.rolByUsu)
      }
    }    
  },
  ///Para borrar el valor del userMail actual al salir de la ventana
  beforeRouteLeave(to, from, next) {
    // Limpia el userMail antes de salir de la ruta
    localStorage.removeItem('userIdTrab');
    this.$store.commit('enviarCorreo', '');    
    next();
  },
  computed: {
    /// del v-select en el modalApps
    filteredAplicaciones() {
      const lowerSearchTextApp = this.searchTextApp.toLowerCase();
      return this.apps.map(app => {
        if (app && app.descripcion) {
          return {
            ...app,
            nombreAplicacion: `${app.descripcion}`
          };
        }
        return null;
      }).filter(app => app && (
        app.descripcion.toLowerCase().includes(lowerSearchTextApp)
      ));
    },

    /// del v-select en el modalArea
    filteredAreas() {
      const lowerSearchTextArea = this.searchTextArea.toLowerCase();
      return this.areas.map(area => {
        if (area && area.descripcion) {
          return {
            ...area,
            nombreArea: `${area.descripcion}`
          };
        }
        return null;
      }).filter(area => area && (
        area.descripcion.toLowerCase().includes(lowerSearchTextArea)
      ));
    },
    /// del v-select 1 en el modalRol
    filteredAppsById() {
      const lowerSearchTextAppById = this.searchTextAppById.toLowerCase();
      return this.appById.map(ap => {
        if (ap && ap.descripcion) {
          return {
            ...ap,
            nombreAppById: `${ap.descripcion}`
          };
        }
        return null;
      }).filter(ap => ap && (
        ap.descripcion.toLowerCase().includes(lowerSearchTextAppById)
      ));
    },
    /// del v-select 2 en el modalRol
    filteredRoles() {
      const lowerSearchTextRol = this.searchTextRol.toLowerCase();
      return this.rolByApp.map(ro => {
        if (ro && ro.descripcion) {
          return {
            ...ro,
            nombreRol: `${ro.descripcion}`
          };
        }
        return null;
      }).filter(ro => ro && (
        ro.descripcion.toLowerCase().includes(lowerSearchTextRol)
      ));
    },
  },
}

</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.datetime-picker input {
  height: 2em !important;
  border: 1px solid #fff !important;
}

.fuente-subtitulo {
  /*display: grid;*/
  place-items: center;
  font-weight: bold;
  /*text-decoration: underline;*/
}
</style>



// WEBPACK FOOTER //
// Usuarios.vue?772bdd91